import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Endpoints, InitGameResponseKeys, GameResponseKeys, FavouriteResponseKeys } from './Constants';
import RequestHelper from './RequestHelper';
import transformObjectArrayResponse from '../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../utils/transformObjectResponseKeys';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
import Utils from '../utils/game';
import Platform from '../utils';
import store from '../state/store';
import { setGameType, setGameProvider } from '../state/actions/game';
import { getInitGame } from '../state/query/games';
import ERROR_CODE from '../utils/errorCodes';
/** @typedef {import('../api/Constants').GameRoomsResponse} GameRoomsResponse */

export default {
  /**
   * Helper method to get game rooms
   * @async
   * @public
   * @returns {GameRoomsResponse}
   */
  getGameRooms: function () {
    var _getGameRooms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var callResponse, eventPayload, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_GAME_ROOMS,
                logJSON: true,
                ignoreCache: true
              }, true);

            case 2:
              callResponse = _context.sent;

              if (!(callResponse.success === false)) {
                _context.next = 7;
                break;
              }

              eventPayload = {
                description: "Failed to load game room, ".concat(callResponse.error),
                code: 32
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw Error("[Get-Game-Rooms-response] ".concat(callResponse.error));

            case 7:
              if (!(callResponse === false)) {
                _context.next = 9;
                break;
              }

              throw Error('[Get-Game-Rooms-response] - server returns FALSE');

            case 9:
              // Do transformations on response to make it sensible
              response = callResponse;
              response.featured = transformObjectArrayResponse(response.featured);
              response.new_games = transformObjectArrayResponse(response.new_games);
              response.slots = transformObjectArrayResponse(response.slots);
              response.table = transformObjectArrayResponse(response.table);
              response.configurable_vip = transformObjectArrayResponse(response.configurable_vip);
              response.featured.forEach(function (game, index) {
                response.featured[index] = transformObjectResponseKeys(game, GameResponseKeys);
              });
              response.new_games.forEach(function (game, index) {
                response.new_games[index] = transformObjectResponseKeys(game, GameResponseKeys);
              });
              response.slots.forEach(function (item) {
                item.gameRoomBalanceThreshold.amount = parseInt(item.gameRoomBalanceThreshold.amount);
                item.games = transformObjectArrayResponse(item.games);
                item.games.forEach(function (game, index) {
                  item.games[index] = transformObjectResponseKeys(game, GameResponseKeys);
                });
              });
              response.table.forEach(function (item) {
                item.gameRoomBalanceThreshold.amount = parseInt(item.gameRoomBalanceThreshold.amount);
                item.games = transformObjectArrayResponse(item.games);
                item.games.forEach(function (game, index) {
                  item.games[index] = transformObjectResponseKeys(game, GameResponseKeys);
                });
              });
              response.configurable_vip.forEach(function (item) {
                item.gameRoomBalanceThreshold.amount = parseInt(item.gameRoomBalanceThreshold.amount);
                item.games = transformObjectArrayResponse(item.games);
                item.news = transformObjectArrayResponse(item.news);
                item.games.forEach(function (game, index) {
                  item.games[index] = transformObjectResponseKeys(game, GameResponseKeys);
                });
              });
              return _context.abrupt("return", response);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getGameRooms() {
      return _getGameRooms.apply(this, arguments);
    }

    return getGameRooms;
  }(),
  getFavGames: function () {
    var _getFavGames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_FAV_GAMES,
                logJSON: true
              }, true);

            case 2:
              callResponse = _context2.sent;

              if (!(callResponse.success === false)) {
                _context2.next = 5;
                break;
              }

              throw Error("[Get-Fav-Games-response] ".concat(callResponse.error));

            case 5:
              callResponse = transformObjectResponseKeys(callResponse, FavouriteResponseKeys);
              return _context2.abrupt("return", callResponse);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getFavGames() {
      return _getFavGames.apply(this, arguments);
    }

    return getFavGames;
  }(),

  /**
   * Helper Method to send server request to init a game
   * @async
   * @public
   * @param {Number} gameId - Id of the game to be init
   * @returns {InitGameResponseKeys} Game response
   */
  initGame: function () {
    var _initGame = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(gameId) {
      var isEmbedded, gameDownloadFailed, iosPlatform, callResponse, unlockLevel, isFeatured, trigger, gameType, gameProvider, eventPayload;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isEmbedded = store.getState().gameInfo.isEmbedded;
              gameDownloadFailed = store.getState().gameDownload.downloadFailedGames[gameId];
              iosPlatform = Platform.getPlatform() === 'ios';
              _context3.prev = 3;
              _context3.next = 6;
              return store.dispatch(getInitGame.initiate({
                gameId: gameId,
                isEmbedded: isEmbedded,
                gameDownloadFailed: gameDownloadFailed,
                iosPlatform: iosPlatform
              }, {
                forceRefetch: true
              })).unwrap();

            case 6:
              callResponse = _context3.sent;
              _context3.next = 13;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](3);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context3.t0, Object.getOwnPropertyNames(_context3.t0)),
                code: ERROR_CODE.INIT_GAME_FAIL
              });
              return _context3.abrupt("return", false);

            case 13:
              if (!(callResponse === false)) {
                _context3.next = 15;
                break;
              }

              return _context3.abrupt("return", false);

            case 15:
              unlockLevel = {};

              if (callResponse && callResponse[3]) {
                unlockLevel = Utils.getUnlockLevel(gameId, callResponse[3]);
              } else {
                unlockLevel = false;
              }

              isFeatured = Utils.isFeaturedGame(gameId) ? 'true' : 'false';

              if (unlockLevel) {
                trigger = Logger.getActionTrigger();
                gameType = callResponse[3] && callResponse[3].toLowerCase();
                gameProvider = callResponse[1].toLowerCase();
                store.dispatch(setGameType(gameType));
                store.dispatch(setGameProvider(gameProvider));
                eventPayload = {
                  trigger: trigger,
                  game_type: gameType || 'slots',
                  is_featured: !gameType || isFeatured,
                  unlock_level: unlockLevel.UNLOCK_LEVEL
                };
                Logger.sendEvent(EVENT_TYPES.GAME_INIT, eventPayload);
              }

              return _context3.abrupt("return", transformObjectResponseKeys(_objectSpread(_objectSpread({}, callResponse), {}, {
                3: callResponse[3] || 'slots'
              }), InitGameResponseKeys));

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 9]]);
    }));

    function initGame(_x) {
      return _initGame.apply(this, arguments);
    }

    return initGame;
  }()
};